import type { Theme } from '@mui/material/styles';

const DEFAULT_PASSWORD_STRENGTH_COLORS = {
  gradientStart: [255, 179, 0],
  gradientEnd: [46, 125, 50],
  legendary: '#8e24aa',
} as const;

function interpolateColor(start: readonly number[], end: readonly number[], progress: number) {
  return `rgb(${start.map((color, index) => Math.round(color + (end[index] - color) * progress)).join(' ')})`;
}

export function getPasswordStrengthColor(theme: Theme, strength: number, accepted: boolean) {
  const colors = theme.palette.passwordStrength ?? DEFAULT_PASSWORD_STRENGTH_COLORS;

  if (!accepted) {
    return theme.palette.error.main;
  }
  if (strength < 60) {
    return theme.palette.warning.main;
  }
  if (strength <= 110) {
    return interpolateColor(colors.gradientStart, colors.gradientEnd, (strength - 60) / 50);
  }
  return colors.legendary;
}
